import Vue from 'vue'
import VueRouter from 'vue-router'
import Parent from '../views/Parent.vue'
import Kid from '../views/Kid.vue'
import BaseSetting from '../views/BaseSettings'
import Login from "../views/Login";
import PageNotFound from "../views/PageNotFound";
import PremiumNoLogin from "../views/PremiumNoLogin";
import LandingFlow from "../views/LandingFlow";
// import Welcome from "../views/Welcome";
import firebase from "firebase/app";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Parent
  },
  {
    path: '/kid',
    component: Kid
  },
  {
    path: '/settings',
    component: BaseSetting
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/premium',
    component: PremiumNoLogin
  },
  {
    path: '/landing-flow',
    component: LandingFlow
  },
/*  {
    path: '/welcome',
    component: Welcome
  },*/
  {
    path: "*",
    component: PageNotFound
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const { query } = to;
  if ('enterTestmode' in query) {
    if (query.enterTestmode ==='1') {
      localStorage.setItem('stripeTest', '1');
      alert('test payment mode activate');
    } else {
      localStorage.removeItem('stripeTest');
      alert('test payment mode inactive')
    }
  }

  if (query.extID) {
    localStorage.setItem('extID', query.extID)
  }

  if (query.testNavigation || window.Android) { // for mobile testing
    next();
    return;
  }

  if (to.path === '/premium' || to.path === '/landing-flow') {
    next();
    return;
  }

  const isRemote = localStorage.getItem('isRemote');
  const remoteConditionRedirect = isRemote && JSON.parse(isRemote) && to.path !== '/login';
  const user = firebase.auth().currentUser
  if (remoteConditionRedirect) {
    if (user && user.email) {
      firebase.database().ref('users/' + user.uid + '/settings/isPremium/').get().then((snapshot) => {
        if (snapshot.exists() && snapshot.val()) {
          next()
        } else {
          next('/login')
        }
      })
    } else {
      next('/login')
    }
  } else {
      next()
  }
})

export default router
